import Navbar from "../../../components/Navbar/Navbar";
import InsuranceDocument from "../components/Insurance/InsuranceDocument/InsuranceDocument";

export default function InsuranceDocumentPage() {
    return (
        <>
            <Navbar />
            <InsuranceDocument />
        </>
    );
}
